import React, { Component } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './editor.css';

const EditorComponent = props => {
  return (
    <React.Fragment>
      <span className="input__title">{props.title}</span>

      <Editor
        toolbarOnFocus
        stripPastedStyles={true}
        toolbar={{
          options: ['inline', 'link', 'emoji'],
          inline: {
            options: ['bold', 'italic', 'underline']
          }
        }}
        toolbarClassName="editor-toolbar"
        editorClassName="editor-textarea"
        wrapperClassName="wrapper-editor"
        editorState={props.editorState}
        onEditorStateChange={props.onEditorStateChange}
      />
    </React.Fragment>
  );
};
export default EditorComponent;
